import React, { useState } from 'react';
import queryString from 'query-string';
import IntegrationContext from './IntegrationContext';
import { IntegrationMode } from '../utils/IntegrationConstants';

const IntegrationContextProvider = (props) => {
  const getIntegrationMode = () => {
    const url = window.location.href;
    const parsedUrl = queryString.parseUrl(url);

    // If app is not in an iFrame, disable integration mode
    if (window.top === window.self || !parsedUrl.query.im) {
      return IntegrationMode.Normal;
    }

    switch (parsedUrl.query.im) {
      case 'teams':
      case '1':
        return IntegrationMode.Teams;

      default:
        return IntegrationMode.Normal;
    }
  };

  const defaultIntegrationContext = { mode: getIntegrationMode() };

  const [integrationContext, setIntegrationContext] = useState(defaultIntegrationContext);

  const value = { integrationContext, setIntegrationContext };
  return <IntegrationContext.Provider value={value} {...props} />;
};

export default IntegrationContextProvider;
